export default __webpack_public_path__ + "1eadd7561ea00e5f613e5577b44e2c75.svg";